import styled from 'styled-components'

const Container = styled.div`
  height: 100%;
  ${props => props.renderTrigger && `position: relative;`};
`

export default Container
